export const FOOTER_LOCALE_ZHCHS = {
    expandText: 'æ¥çæ´å¤ä¿¡æ¯',
    collapseText: 'æ¥çæ´å¤ä¿¡æ¯'
};
